import { ChevronRightIcon, Typography, styledComponent } from '@hermes/web-components'

export const InputGradientText = styledComponent(Typography, {
  shouldForwardProp: (prop: string) => !['isActive', 'isError'].includes(prop)
})<{ isActive?: boolean; isError?: boolean }>(({ isActive, isError }) => ({
  background: isActive
    ? 'linear-gradient(90deg, rgba(43, 89, 224, 0.70) 50%, rgba(14, 182, 213, 0.51) 83.26%, rgba(0, 229, 208, 0.70) 99.99%, rgba(0, 229, 208, 0.70) 100%, rgba(0, 229, 208, 0.42) 100%, rgba(13, 187, 213, 0.70) 100%), #2B59E0'
    : '#4C5870',
  ...(isError && { background: '#CC4F4A' }),
  backgroundClip: 'text',
  pointerEvents: 'none',
  WebkitTextFillColor: 'transparent',
  fontWeight: isActive ? 600 : 500,
  fontSize: '13px',
  lineHeight: '20px',
  marginBottom: '4px'
}))

export const InputText = styledComponent(Typography, {
  shouldForwardProp: (prop: string) => !['isActive'].includes(prop)
})<{ isActive?: boolean }>(({ isActive }) => ({
  color: isActive ? '#2247B3' : '#1A3586',
  fontSize: '13px',
  lineHeight: '20px',
  fontWeight: isActive ? '400' : '500'
}))

export const StyledChevronRightIcon = styledComponent(ChevronRightIcon, {
  shouldForwardProp: (prop: string) => !['isOpen'].includes(prop)
})<{ isOpen?: boolean }>(({ isOpen }) => ({
  rotate: isOpen ? '270deg' : '90deg',
  width: '24px',
  height: '24px',
  color: '#1A3586',
  transition: 'all 0.3s ease-in-out'
}))
